import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Row, Button, Modal } from 'antd';
import get from 'lodash/get';
import { permissionService } from 'shared/services';
import { FILTER_TYPE, paginationParam } from 'shared/constant';

import { Link } from 'react-router-dom';
import CallbackModal from 'components/CallbackModal';
import Table from 'components/Table';
import NewFilter from 'components/NewFilter';
import urlUtil from 'shared/utils/UrlUtil';
import { formatMoney } from 'shared/utils/StringUtil';

import text from './Transactions.page.translation';
import TransactionDetailModal from './TransactionDetailModal';
import './Transactions.style.less';
import {
  ORDER_STATUS,
  REFUND_STATUS,
  DANA_ORDER_TYPE,
} from '../../constant/AllBillerDefaultVar';

import allBillersRoute from '../../route';

class Transactions extends PureComponent {
  constructor(props) {
    super(props);

    const { resetFilter, match } = this.props;
    if (!match.params.page) {
      resetFilter();
    }
  }

  componentDidMount = () => {
    const { match, filterValue } = this.props;
    if (match.params.page) {
      this.updateTransactionTable(filterValue);
    } else {
      this.updateTransactionTable([]);
    }
  };

  componentDidUpdate(prevProps) {
    const { formControlShow, match, filterValue } = this.props;

    if (prevProps.match.params.page !== match.params.page) {
      this.updateTransactionTable(filterValue);
    }

    if (prevProps.filterValue !== filterValue && !formControlShow) {
      if (
        !(
          prevProps.filterValue.length > 0 &&
          prevProps.filterValue.length > filterValue.length &&
          prevProps.filterValue[prevProps.filterValue.length - 1].inputValue
            .length === 0
        )
      ) {
        if (
          prevProps.match.params.page !== match.params.page ||
          (prevProps.match.params.page === match.params.page &&
            match.params.page > 1)
        ) {
          this.handleChangePage(1);
        } else {
          this.updateTransactionTable(filterValue);
        }
      }
    }
  }

  renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Row className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(text.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {formatMessage(text.transactionsTitle)}
          </Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    );
  };

  renderNoColumn = (pageNum, pageSize) => (_text, _record, index) => {
    const result = index + 1 + pageSize * (pageNum - 1);
    return result;
  };

  onClickTransactionId = record => event => {
    event.preventDefault();
    this.props.getInvoice(record.id);
  };

  onClickCancelTransactionDetailModal = () => {
    this.props.setTransactionDetailModal(false, []);
  };

  renderTransactionId = (transactionId, record) => {
    const orderStatus = get(record, 'order_status');
    const danaOrderType = get(record, 'dana_order_type');

    let disabled = false;
    if (
      orderStatus === ORDER_STATUS.INIT ||
      orderStatus === ORDER_STATUS.EXPIRED ||
      danaOrderType === DANA_ORDER_TYPE.FUND
    ) {
      disabled = true;
    }

    return (
      <Button
        type="link"
        onClick={this.onClickTransactionId(record)}
        className="button-link"
        disabled={disabled}
      >
        {transactionId}
      </Button>
    );
  };

  onClickRefund = selectedId => event => {
    const { setTransactionRefundConfirmModal } = this.props;

    event.preventDefault();
    setTransactionRefundConfirmModal(true, selectedId);
  };

  renderAction = record => {
    const { checkPermission } = permissionService;
    const orderStatus = get(record, 'order_status');
    const refundStatus = get(record, 'refund_status');

    const id = get(record, 'id');

    let disabled = true;
    if (
      ((orderStatus === ORDER_STATUS.FAILED &&
        refundStatus === REFUND_STATUS.PROGRESS) ||
        (orderStatus === ORDER_STATUS.FAILED &&
          refundStatus === REFUND_STATUS.MANUAL_REFUND) ||
        (orderStatus === ORDER_STATUS.URGENT &&
          refundStatus === REFUND_STATUS.MANUAL_REFUND) ||
        (orderStatus === ORDER_STATUS.DANGER &&
          refundStatus === REFUND_STATUS.MANUAL_REFUND)) &&
      checkPermission('Transaction Log:update', true)
    ) {
      disabled = false;
    }

    return (
      <Button
        size="small"
        type="primary"
        onClick={this.onClickRefund(id)}
        className="button-link"
        disabled={disabled}
      >
        Refund
      </Button>
    );
  };

  renderCurrency = currencyString => {
    if (currencyString) {
      return formatMoney(currencyString);
    }

    return '';
  };

  renderAcquiringOnlyCurrency = (currencyString, record) => {
    const danaOrderType = get(record, 'dana_order_type');

    let result = '';
    if (danaOrderType === DANA_ORDER_TYPE.FUND) {
      result = this.renderCurrency('0');
    } else {
      result = this.renderCurrency(currencyString);
    }

    return result;
  };

  renderColumns(pageNum, pageSize, formatMessage) {
    return [
      {
        title: formatMessage(text.table.labelNo),
        key: 'index',
        render: this.renderNoColumn(pageNum, pageSize),
        width: 100,
      },
      {
        title: formatMessage(text.table.danaOrderType),
        key: 'danaOrderType',
        dataIndex: 'dana_order_type',
        width: 250,
      },
      {
        title: formatMessage(text.table.createdAt),
        key: 'updatedAt',
        dataIndex: 'created_at',
        width: 300,
      },
      {
        title: formatMessage(text.table.updatedAt),
        key: 'updatedAt',
        dataIndex: 'updated_at',
        width: 300,
      },
      {
        title: formatMessage(text.table.danaFinishTime),
        key: 'danaFinishTime',
        dataIndex: 'dana_finish_time',
        width: 250,
      },
      {
        title: formatMessage(text.table.aggregatorFinishTime),
        key: 'aggregatorFinishTime',
        dataIndex: 'aggregator_finish_time',
        width: 250,
      },
      {
        title: formatMessage(text.table.transactionId),
        key: 'transactionId',
        dataIndex: 'public_id',
        width: 100,
        render: this.renderTransactionId,
      },
      {
        title: formatMessage(text.table.orderStatus),
        key: 'order_status',
        dataIndex: 'order_status',
        width: 250,
      },
      {
        title: formatMessage(text.table.danaOrderId),
        key: 'danaOrderId',
        dataIndex: 'dana_order_id',
        width: 400,
      },
      {
        title: formatMessage(text.table.customerId),
        key: 'customerId',
        dataIndex: 'beneficiary_account_number',
        width: 450,
      },
      {
        title: formatMessage(text.table.serviceName),
        key: 'serviceName',
        dataIndex: 'biller.service.name',
        width: 300,
      },
      {
        title: formatMessage(text.table.serviceCategory),
        key: 'serviceCategory',
        dataIndex: 'biller.service.category',
        width: 300,
      },
      {
        title: formatMessage(text.table.billerName),
        key: 'billerName',
        dataIndex: 'biller.name',
        width: 300,
      },
      {
        title: formatMessage(text.table.aggregatorId),
        key: 'aggregatorId',
        dataIndex: 'aggregator.public_id',
        width: 150,
      },
      {
        title: formatMessage(text.table.aggregatorName),
        key: 'aggregatorName',
        dataIndex: 'aggregator.name',
        width: 300,
      },
      {
        title: formatMessage(text.table.danaPublicId),
        key: 'danaPublicId',
        dataIndex: 'dana_public_id',
        width: 450,
      },
      {
        title: formatMessage(text.table.transactionAmount),
        key: 'transactionAmount',
        dataIndex: 'transaction_amount',
        width: 250,
        render: this.renderCurrency,
      },
      {
        title: formatMessage(text.table.aggregatorFee),
        key: 'aggregatorFee',
        dataIndex: 'aggregator_fee',
        width: 250,
        render: this.renderCurrency,
      },
      {
        title: formatMessage(text.table.aggregatorServiceTax),
        key: 'aggregatorServiceTax',
        dataIndex: 'aggregator_service_tax',
        width: 300,
        render: this.renderAcquiringOnlyCurrency,
      },
      {
        title: formatMessage(text.table.transactionFee),
        key: 'transactionFee',
        dataIndex: 'transaction_fee',
        width: 200,
        render: this.renderCurrency,
      },
      {
        title: formatMessage(text.table.totalAmountDana),
        key: 'totalAmountDana',
        dataIndex: 'total_amount_dana',
        width: 200,
        render: this.renderCurrency,
      },
      {
        title: formatMessage(text.table.totalAmountAggregator),
        key: 'totalAmountAggregator',
        dataIndex: 'total_amount_aggregator',
        width: 300,
        render: this.renderAcquiringOnlyCurrency,
      },
      {
        title: formatMessage(text.table.action),
        key: 'action',
        render: this.renderAction,
        width: 200,
      },
    ];
  }

  getColumnsScrollX = columns => {
    const result = columns
      .map(x => x.width)
      .reduce((prev, next) => prev + next);
    return result;
  };

  getRowKey = record => record.id;

  handleChangePage = page => {
    urlUtil.changePageParams(
      allBillersRoute.TRANSACTIONS,
      page,
      this.props.history,
    );
  };

  renderRefundConfirmModal = () => {
    const {
      transactionRefundConfirmModalShow,
      cancelOrderLoading,
    } = this.props;

    return (
      <Modal
        className="transaction-refund-confirm-modal"
        bodyStyle={{ padding: '0px' }}
        width={400}
        centered
        title=""
        closable={false}
        visible={transactionRefundConfirmModalShow}
        footer={null}
      >
        <div className="modal-header-container">Confirmation</div>
        <div className="modal-separator" />
        <div className="modal-body-container">
          Are you sure want to <span className="bold">refund?</span>
        </div>
        <div className="footer-btn-container">
          <Button onClick={this.onCancelRefund} disabled={cancelOrderLoading}>
            Cancel
          </Button>
          <Button
            className="footer-btn-refund"
            type="danger"
            onClick={this.onSubmitRefund}
            loading={cancelOrderLoading}
          >
            Refund
          </Button>
        </div>
      </Modal>
    );
  };

  onCancelRefund = () => {
    const { setTransactionRefundConfirmModal } = this.props;

    setTransactionRefundConfirmModal(false);
  };

  onSubmitRefund = () => {
    const { cancelOrder, transactionRefundSelectedId } = this.props;

    cancelOrder(transactionRefundSelectedId);
  };

  renderRefundSuccessModal = () => {
    const { cancelOrderResponse } = this.props;
    const description = this.renderRefundSuccessDescription();

    return (
      <CallbackModal
        modalVisible={cancelOrderResponse.status}
        type="success"
        description={description}
        onClose={this.onCloseRefundSuccessModal}
      ></CallbackModal>
    );
  };

  renderRefundSuccessDescription = () => (
    <div className="refund-modal-description">
      <div>Refund Success</div>
      <div>
        <strong>(Refresh to update data)</strong>
      </div>
    </div>
  );

  onCloseRefundSuccessModal = () => {
    const { resetCancelOrder } = this.props;

    resetCancelOrder();
  };

  renderRefundErrorModal = () => {
    const { cancelOrderError } = this.props;
    const errorTitle = get(cancelOrderError, 'message.title');
    const errorDetail = get(cancelOrderError, 'message.detail');
    const description = this.renderRefundErrorDescription(
      errorTitle,
      errorDetail,
    );

    return (
      <CallbackModal
        modalVisible={cancelOrderError.status}
        type="failed"
        description={description}
        onClose={this.onCloseRefundErrorModal}
      ></CallbackModal>
    );
  };

  renderRefundErrorDescription = (errorTitle, errorDetail) => (
    <div className="refund-modal-description">
      <div>
        error &quot;<strong>{errorTitle}</strong>&quot;
      </div>
      <div>{errorDetail}</div>
    </div>
  );

  onCloseRefundErrorModal = () => {
    const { resetCancelOrder } = this.props;

    resetCancelOrder();
  };

  overrideOrderStatus = filterValue => {
    if (filterValue.some(x => x.key === 'refund_status')) {
      return filterValue.filter(x => x.key !== 'order_status');
    }

    return filterValue;
  };

  buildGetParamUrl = filterValue => {
    let result = '';

    // refund_status will override order_status
    const newFilterValue = this.overrideOrderStatus(filterValue);

    newFilterValue.forEach(element => {
      const value = element.inputValue[0];
      switch (element.key) {
        case 'aggregator_finish_time':
          result += `&aggregator_finish_time_from=${value}`;
          result += `&aggregator_finish_time_until=${element.inputValue[1]}`;
          break;
        case 'created_at':
          result += `&created_from=${value}&created_until=${
            element.inputValue[1]
          }`;
          break;
        case 'refund_status':
          if (value === 'manualRefund') {
            result += `&order_status=${ORDER_STATUS.FAILED},${ORDER_STATUS.URGENT},${ORDER_STATUS.DANGER}`;
            result += `&refund_status=${REFUND_STATUS.PROGRESS},${REFUND_STATUS.MANUAL_REFUND}`;
          } else if (value === 'noRefund') {
            result += `&order_status=${ORDER_STATUS.INIT},${ORDER_STATUS.IN_PROGRESS},${ORDER_STATUS.COMPLETED},${ORDER_STATUS.REFUNDED},${ORDER_STATUS.EXPIRED},${ORDER_STATUS.WARNING},${ORDER_STATUS.SUSPECT}`;
            result += `&refund_status=${REFUND_STATUS.INIT},${REFUND_STATUS.REFUNDED}`;
          }
          break;
        case 'public_id_so':
          result += `&public_id=${value}`;
          break;
        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  buildPaginationUrl = transactionsFilter => {
    let result = '';
    result += `page_size=${encodeURIComponent(transactionsFilter.page_size)}`;
    result += `&page_count=${encodeURIComponent(
      transactionsFilter.page_count,
    )}`;
    result += `&page_num=${encodeURIComponent(transactionsFilter.page_num)}`;

    return result;
  };

  updateTransactionTable = filterValue => {
    const {
      getListTransactions,
      transactionsFilter,
      match,
      history,
    } = this.props;

    let paginationValue = { ...paginationParam };
    let paramUrl = '';
    const page = get(match, 'params.page', '');
    const pageInt = parseInt(page, 10) || '';

    if (filterValue.length > 0) {
      paramUrl = this.buildGetParamUrl(filterValue);
    }

    if (page) {
      if (pageInt && pageInt >= 1) {
        paginationValue = {
          ...transactionsFilter,
          page_num: pageInt,
        };
        const paginationUrl = this.buildPaginationUrl(paginationValue);
        getListTransactions(paginationUrl, paramUrl);
      } else {
        history.push(allBillersRoute.TRANSACTIONS);
      }
    } else {
      const paginationUrl = this.buildPaginationUrl(paginationValue);
      getListTransactions(paginationUrl, paramUrl);
    }
  };

  refreshTable = () => {
    const { getListTransactions, transactionsFilter, filterValue } = this.props;
    const paginationUrl = this.buildPaginationUrl(transactionsFilter);
    const paramUrl = this.buildGetParamUrl(filterValue);

    getListTransactions(paginationUrl, paramUrl);
  };

  goToMeta = () => {
    this.props.history.push(allBillersRoute.TRANSACTION_META);
  };

  render() {
    const {
      intl: { formatMessage },
      loading,
      listTransactions,
      transactionsFilter,
      transactionDetailModalShow,
      transactionDetailModalData,
    } = this.props;

    const pageSize = get(transactionsFilter, 'page_size');
    const pageCount = get(transactionsFilter, 'page_count');
    const pageNum = get(transactionsFilter, 'page_num');
    const totalItem = pageSize * pageCount;

    const tableColumns = this.renderColumns(pageNum, pageSize, formatMessage);
    const scrollX = this.getColumnsScrollX(tableColumns);

    const refundConfirmModal = this.renderRefundConfirmModal();
    const refundSuccessModal = this.renderRefundSuccessModal();
    const refundErrorModal = this.renderRefundErrorModal();

    const options = [
      {
        optGroupLabel: 'Public Id',
        children: [
          {
            label: 'Public Id (standard)',
            value: 'public_id',
            type: FILTER_TYPE.TEXT,
          },
          {
            label: 'Public Id (shortened)',
            value: 'public_id_suffix',
            type: FILTER_TYPE.TEXT,
            validations: [
              {
                min: 4,
                message: formatMessage(text.filter.errorMessage.shortenedTrxId),
              },
              {
                max: 4,
                message: formatMessage(text.filter.errorMessage.shortenedTrxId),
              },
            ],
          },
        ],
      },
      {
        label: formatMessage(text.table.danaOrderType),
        value: 'dana_order_type',
        type: FILTER_TYPE.RADIO,
        options: [
          {
            value: DANA_ORDER_TYPE.ACQUIRING,
            label: DANA_ORDER_TYPE.ACQUIRING,
          },
          {
            value: DANA_ORDER_TYPE.FUND,
            label: DANA_ORDER_TYPE.FUND,
          },
        ],
      },
      {
        label: formatMessage(text.table.danaOrderId),
        value: 'dana_order_id',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.table.customerId),
        value: 'beneficiary_account_number',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.table.orderStatus),
        value: 'order_status',
        type: FILTER_TYPE.RADIO,
        options: [
          {
            value: ORDER_STATUS.INIT,
            label: formatMessage(text.filter.orderStatus.init),
          },
          {
            value: ORDER_STATUS.IN_PROGRESS,
            label: formatMessage(text.filter.orderStatus.inProgress),
          },
          {
            value: ORDER_STATUS.FAILED,
            label: formatMessage(text.filter.orderStatus.failed),
          },
          {
            value: ORDER_STATUS.REFUNDED,
            label: formatMessage(text.filter.orderStatus.refunded),
          },
          {
            value: ORDER_STATUS.EXPIRED,
            label: formatMessage(text.filter.orderStatus.expired),
          },
          {
            value: ORDER_STATUS.COMPLETED,
            label: formatMessage(text.filter.orderStatus.completed),
          },
          {
            value: ORDER_STATUS.WARNING,
            label: formatMessage(text.filter.orderStatus.warning),
          },
          {
            value: ORDER_STATUS.URGENT,
            label: formatMessage(text.filter.orderStatus.urgent),
          },
          {
            value: ORDER_STATUS.SUSPECT,
            label: formatMessage(text.filter.orderStatus.suspect),
          },
          {
            value: ORDER_STATUS.DANGER,
            label: formatMessage(text.filter.orderStatus.danger),
          },
          {
            value: ORDER_STATUS.CONFIRMED,
            label: formatMessage(text.filter.orderStatus.confirmed),
          },
          {
            value: ORDER_STATUS.SUBMITTED,
            label: formatMessage(text.filter.orderStatus.submitted),
          },
          {
            value: ORDER_STATUS.DECLINED,
            label: formatMessage(text.filter.orderStatus.declined),
          },
          {
            value: ORDER_STATUS.REOPENED,
            label: formatMessage(text.filter.orderStatus.reopened),
          },
        ],
      },
      {
        label: 'Created At',
        value: 'created_at',
        type: FILTER_TYPE.RANGE_PICKER,
      },
      {
        label: formatMessage(text.table.aggregatorFinishTime),
        value: 'aggregator_finish_time',
        type: FILTER_TYPE.RANGE_PICKER,
      },
      {
        label: formatMessage(text.table.serviceName),
        value: 'service_name',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.table.serviceCategory),
        value: 'service_category',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.table.billerName),
        value: 'biller_name',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.table.aggregatorName),
        value: 'aggregator_name',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: 'Refund Status',
        value: 'refund_status',
        type: FILTER_TYPE.RADIO,
        options: [
          { label: 'Manual Refund', value: 'manualRefund' },
          { label: 'No Refund', value: 'noRefund' },
        ],
      },
    ];

    return (
      <div className="main-content transactions-page">
        {this.renderBreadCrumb()}

        <div className="white-box-wrapper">
          <div className="title mbottom30 title-trx">
            <div className="title-trx-left">
              {formatMessage(text.transactionsTitle)}
            </div>
            <div>
              <Button
                style={{ marginRight: '16px' }}
                type="primary"
                onClick={this.goToMeta}
              >
                Download
              </Button>
              <Button type="primary" onClick={this.refreshTable}>
                Refresh
              </Button>
            </div>
          </div>
          <NewFilter options={options} />
          <div className="table-wrapper">
            <Table
              bordered
              columns={tableColumns}
              dataSource={listTransactions}
              pagination="true"
              rowKey={this.getRowKey}
              rowClass="striped-table"
              loadingValue={loading}
              totalItem={totalItem}
              currentPage={pageNum}
              changePage={this.handleChangePage}
              scrollX={scrollX}
            />
          </div>
        </div>
        <TransactionDetailModal
          visible={transactionDetailModalShow}
          data={transactionDetailModalData}
          handleCancel={this.onClickCancelTransactionDetailModal}
          formatMessage={formatMessage}
        />
        {refundConfirmModal}
        {refundSuccessModal}
        {refundErrorModal}
      </div>
    );
  }
}

Transactions.propTypes = {
  intl: PropTypes.object,
  loading: PropTypes.bool,
  history: PropTypes.object,
  listTransactions: PropTypes.array,
  getListTransactions: PropTypes.func,
  getInvoice: PropTypes.func,
  transactionsFilter: PropTypes.object,
  setTransactionDetailModal: PropTypes.func,
  transactionDetailModalShow: PropTypes.bool,
  transactionDetailModalData: PropTypes.array,
  transactionRefundConfirmModalShow: PropTypes.bool,
  transactionRefundSelectedId: PropTypes.string,
  setTransactionRefundConfirmModal: PropTypes.func,
  filterValue: PropTypes.array,
  resetFilter: PropTypes.func,
  cancelOrder: PropTypes.func,
  cancelOrderResponse: PropTypes.object,
  resetCancelOrder: PropTypes.func,
  cancelOrderLoading: PropTypes.bool,
  cancelOrderError: PropTypes.object,
  formControlShow: PropTypes.bool,
  match: PropTypes.object,
};

export default Transactions;
